export default class EventBus extends EventTarget {

    constructor(userId, channel) {
        super();
        this.userId = userId;
        this.channel = channel;
    }

    // remote events
    pushRemote(eventName, eventDetail) {
        eventDetail = eventDetail || {};
        this.channel.push(eventName, eventDetail);
    }

    onRemote(eventName, callback) {
        const ref = this.channel.on(eventName, callback);
        return ref;
    }

    offRemote(eventName, ref) {
        this.channel.off(eventName, ref);
    }

    // mixed remote and local events
    pushAll(eventName, eventDetail) {
        eventDetail = eventDetail || {};
        this.pushRemote(eventName, eventDetail);
        this.pushLocal(eventName, eventDetail);
    }

    onAll(eventName, callback) {
        this.onRemote(eventName, callback);
        this.addEventListener(eventName, callback);
    }

    // local events
    pushLocal(eventName, eventDetail) {
        eventDetail = eventDetail || {};
        this.dispatchEvent(new CustomEvent(eventName, { detail: eventDetail }));
    }

    on(eventName, callback) {
        this.addEventListener(eventName, callback);
    }

    once(eventName, callback) {
        this.addEventListener(eventName, callback, { once: true });
    }

    off(eventName, callback) {
        this.removeEventListener(eventName, callback);
    }
}
